const A7Login = () =>
  import ('@/components/sessao/A7Login')
const A7Aplicacao = () =>
  import ('@/components/A7Aplicacao')
const A7Painel = () =>
  import ('@/components/painel/A7Painel')
const A7PainelAnalise = () =>
  import ('@/components/painel-analise/A7PainelAnalise')
const A7DashboardGeral = () =>
  import ('@/components/dashboards/A7DashboardGeral')

export default [{
    path: '/login',
    name: 'login',
    component: A7Login
  },
  {
    path: '/',
    name: 'aplicacao',
    component: A7Aplicacao,
    meta: {
      authRequired: true
    },
    children: [
      {
        path: '/',
        redirect: {name: 'painel'}
      },
      {
        path: '/painel',
        name: 'painel',
        component: A7Painel
      },
      {
        path: '/painelanalise',
        name: 'painelanalise',
        component: A7PainelAnalise
      },
      {
        path: '/dashboardgeral',
        name: 'dashboardgeral',
        component: A7DashboardGeral
      }
    ]
  }
]
